// extracted by mini-css-extract-plugin
module.exports = {"buttons":"QuestionTestType_buttons__2XgmH","testDateContainer":"QuestionTestType_testDateContainer__3gNVN","testDateSelect":"QuestionTestType_testDateSelect__2mTq9"};